import { Button } from 'antd'
import styled from 'styled-components'

import { Segment } from './types'

const ANNOTATE_ICON_URL = `url('data:image/svg+xml,<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.1335 8.00033C14.1335 4.61298 11.3874 1.86686 8.00002 1.86686C4.61267 1.86686 1.86656 4.61298 1.86656 8.00033V14.1338H8.00002V15.3337H0.695984L0.675151 15.3252L0.666687 15.3044V8.00033C0.666687 3.95024 3.94993 0.666992 8.00002 0.666992C12.0501 0.666992 15.3334 3.95024 15.3334 8.00033C15.3334 12.0504 12.0501 15.3337 8.00002 15.3337V14.1338C11.3874 14.1338 14.1335 11.3877 14.1335 8.00033Z" fill="%23a46de8" fill-opacity="0.85"/></svg>')`

export const PageContainer = styled.div`
  min-height: 100vh;
  background: #1f1f1f;
  padding: 20px;
  color: #ffffff;
`

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const STextEmail = styled.span`
  font-size: 14px;
  color: #FFFFFF73;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  font-weight: 400;
  line-height: 22px;
`

export const SText = styled.span`
  font-size: 14px;
  color: #FFFFFFD9;
  font-weight: 400;
  line-height: 22px;
`

export const TitleBox = styled.div`
  display: flex;
`

export { Avatar } from 'shared/ui'

export const PersonalUserMenu = styled.div<{ $isSelected: boolean }>`
  padding: 8px 12px;
  cursor: pointer;
  background-color: ${props => props.$isSelected ? 'rgb(255, 255, 255, 0.08)' : '#141414'};
  color: #fff;
  display: flex;
  gap: 12px;
  align-items: center;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgb(255, 255, 255, 0.08);
  }

  & .ant-avatar {
    width: 32px;
    min-width: 32px;
    height: 32px;
  }
`

export const PopupWrapper = styled.div`
  position: absolute;
  z-index: 1000;
`

export const UserMenu = styled.div`
  border-radius: 4px;
  padding: 4px;
  background-color: #141414;
  max-height: 170px;
  overflow-y: auto;
  width: 220px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transform: translateX(86px) translateY(20px);

  /* Кастомный скроллбар */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background-color: #141414;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: #444444;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background-color: #555555;
  }
  
  /* Стили для Firefox */
  scrollbar-width: thin;
  scrollbar-color: #444444 #141414;
`

export const Header = styled.div`
  text-align: center;
  margin-bottom: 30px;

  h1 {
    color: #ffffff;
    margin-bottom: 8px;
  }

  p {
    color: #a0a0a0;
    font-size: 16px;
    max-width: 500px;
    margin: 0 auto;
  }
`

export const TestContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const EditorContainer = styled.div`
  /* border: 1px solid #424242;
  padding: 12px;
  height: 92px;
  background-color: #141414;
  cursor: text;
  position: relative;
  box-sizing: border-box; */
  padding-bottom: 12px;
  min-height: 40px;

  &:focus {
    outline: none;
    border-color: #888;
  }

  &[data-placeholder]:not([data-placeholder=''])::before {
    content: attr(data-placeholder);
    position: absolute;
    top: 14px;
    left: 12px;
    color: #FFFFFF40;
    pointer-events: none;
  }
`

export const SegmentSpan = styled.span<{ type: Segment['type'] }>`
  color: ${props => {
    if (props.type === 'mention' || props.type === 'mention_in_progress') return 'var(--ant-color-primary-hover)'
    if (props.type === 'annotate') return 'var(--ant-color-primary-hover)'
    return 'inherit'
  }};
  border-radius: 3px;
  padding: 2px 0;
  white-space: pre-wrap;
  vertical-align: middle;
  outline: none;
  cursor: ${props => props.type === 'annotate' ? 'pointer' : 'text'};
  position: relative;

  &[type="annotate"] {
    padding-left: 20px;
  }

  &[type="annotate"]::before {
    content: ${ANNOTATE_ICON_URL};
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
  }
`

export const DebugInfo = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  max-width: 800px;
  background-color: #2f2f2f;
  padding: 15px;
  border-radius: 8px;

  pre {
    text-align: left;
    margin: 0;
    white-space: pre-wrap;
    word-break: break-all;
    flex: 1;
  }
`

export const SuggestionsPopupContainer = styled.ul`
  position: absolute;
  /* We will need to calculate top/left in the component */
  background-color: #3a3a3a;
  border: 1px solid #555;
  border-radius: 6px;
  list-style: none;
  padding: 5px;
  margin: 0;
  width: 250px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 10;
`

export const SuggestionItem = styled.li<{ isActive: boolean }>`
  padding: 8px 12px;
  color: #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  background-color: ${props => (props.isActive ? '#4a90e2' : 'transparent')};
  color: ${props => (props.isActive ? '#ffffff' : '#e0e0e0')};

  &:hover {
    background-color: #4a90e2;
    color: #ffffff;
  }
`

export const SBottomContent = styled.div`
  /* position: absolute;
  bottom: 12px; */
  display: flex;
  /* width: calc(100% - 24px); */
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`

export const SSendButton = styled(Button)`
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
`

export const DropdownMenuContainer = styled.div`
  background-color: #141414;
  border-radius: 8px;
  padding: 8px;
  border: 1px solid var(--color-primary, #51258F);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
`
